// src/products/equityManager/utils/dateFormatter.js
// Utility function to format dates consistently across the equity module
// Format: "5 Nov 2026" (day month year)

export const formatDate = (dateValue) => {
  if (!dateValue) return '—';
  
  try {
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) return '—';
    
    const day = date.getDate();
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    
    return `${day} ${month} ${year}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return '—';
  }
};

export default formatDate;
